document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector(".ts-location-popup");
  const uaSubmitButtons = document.querySelectorAll("[name='ts-select-location']");

  const LOCATION_KEY = "selected_location";
  const DETECTED_KEY = "detected_country";
  const DETECTED_DAYS = 2;

  // The newsletter popup waits for this before starting its own timer, so the
  // two never stack. Always announce, including on every early return.
  function announce(isOpen) {
    document.dispatchEvent(new CustomEvent("ts:location-popup", { detail: { open: isOpen } }));
  }

  function decide(country) {
    if (country === "Ukraine") {
      setCookie(LOCATION_KEY, "Ukraine", 2);
      announce(false);
      return;
    }

    popup.classList.add("active");
    announce(true);
  }

  if (!popup) {
    announce(false);
    return;
  }

  // The theme editor reloads the storefront on every navigation, and the
  // silencing cookie is only written when someone clicks "Ukraine", which
  // nobody does while editing. Outside Ukraine that means the popup reopens
  // on every page and makes the editor unusable.
  if (window.Shopify && window.Shopify.designMode) {
    announce(false);
    return;
  }

  uaSubmitButtons.forEach(uaSubmitButton => {
    uaSubmitButton.addEventListener("click", () => {
      setCookie(LOCATION_KEY, "Ukraine", 2);
      popup.classList.remove("active");
      announce(false);

      if (uaSubmitButton.closest("popover-content")) {
        uaSubmitButton.closest("popover-content").removeAttribute("open");
      }
    });
  })

  if (getCookie(LOCATION_KEY) === "Ukraine") {
    announce(false);
    return;
  }

  // One lookup per visitor rather than one per page view. Whatever page they
  // land on first pays for it; every page after reads the cookie.
  const remembered = getCookie(DETECTED_KEY);
  if (remembered) {
    decide(remembered);
    return;
  }

  fetch("https://ipapi.co/json/")
    .then((response) => response.json())
    .then((data) => {
      const country = data.country_name;

      // No country means the service answered with something other than a
      // result: rate limit, error payload, changed shape. Staying silent is
      // better than showing a Ukrainian shopper a country picker.
      if (!country) {
        announce(false);
        return;
      }

      setCookie(DETECTED_KEY, country, DETECTED_DAYS);
      decide(country);
    })
    .catch((err) => {
      console.warn("Unable to determine country by IP:", err);
      announce(false);
    });
});
